import React from "react";
import SectionTitle from "./SectionTitle";
import {
  Calendar,
  CreditCard,
  Hotel,
  Mail,
  MapPin,
  Notebook,
  NotepadText,
  Package,
  Phone,
  Plane,
  Smartphone,
  User,
} from "lucide-react";
import { ListItem, makeStyles } from "@material-ui/core";
import { CATALOGS } from "components/PackageSelector/PackageSelector";
import moment from "moment";
import { Alert, AlertTitle } from "@material-ui/lab";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  card: {
    background: "#fff",
    borderRadius: "20px",
    border: "4px solid rgba(255, 255, 255, 0.3)",
    boxShadow: "0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgb(0 0 0 / .05)",
    marginBottom: "20px",
    padding: "16px",
    listStyle: "none",
  },
  listItem: {
    padding: 0,
    flexWrap: "wrap",
    "& > ul.info": {
      width: "100%",
    },
  },
  listItemTitle: {
    width: "100%",
  },
  simpleList: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    color: "#676f7e",
    fontSize: "14px",
  },
  label: {
    color: "#676f7e",
    marginBottom: "8px",
    fontSize: "14px",
  },
  simpleListItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginBottom: "12px",
  },
  // Allo step di riepilogo la colonna e' larga tutta la pagina: Cliente e
  // Partecipante stanno affiancati e la pagina si accorcia di parecchio.
  anagraficaColumns: {
    "@media (min-width: 960px)": {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      columnGap: "32px",
      alignItems: "start",
      "& > ul.info": {
        gridColumn: "1 / -1",
        width: "100%",
      },
    },
  },
  // La ListItem che li contiene e' un flex-container: senza larghezza piena
  // i due blocchi si affiancherebbero anche nella sidebar stretta del
  // wizard. La griglia del riepilogo li riporta su due colonne.
  personBlock: {
    minWidth: 0,
    width: "100%",
  },
  flexColumn: {
    flexDirection: "column",
    marginBottom: "16px",
  },
  simpleListItemHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#676f7e",
  },
  strong: {
    color: "#21242c",
  },
  svg: {
    width: "12px",
    height: "12px",
    marginTop: "4px",
  },
  svgBig: {
    width: "16px",
    height: "16px",
  },
  noPadding: {
    padding: 0,
  },
}));

const Resume = (props) => {
  const {
    resumeVariant,
    hasPaymentError,
    packageSelectorState,
    appState,
    nationTitle,
    selectedGroup,
    groupTitle,
    selectedTurn,
    packageTitle,
    departureTitle,
    structureTitle,
    programTypologyTitle,
    enableTagManager,
    summaryStepIndex,
    totalPrice,
    bonusValue,
    visualTotalPrice,
    isMobile,
  } = props;

  const {
    nation: step1Nation,
    catalog: step1Catalog,
    departureService: step1DepartureServiceIds,
    departureServices: cities,
    structure: step1Structure,
    structures,
    programTypology: step1ProgramTypology,
    programTypologies,
  } = packageSelectorState;

  const {
    division,
    // parent
    step1ParentName,
    step1ParentSurname,
    step1ParentFiscalCode,
    step1ParentStreetAddress,
    step1ParentResidenceCity,
    step1ParentCAP,
    step1ParentProv,
    step1ParentEmail,
    step1ParentPhone,
    step1ParentPhoneAlt,
    // child
    step1ChildName,
    step1ChildSurname,
    step1ChildFiscalCode,
    step1ChildStreetAddress,
    step1ChildResidenceCity,
    step1ChildCAP,
    step1ChildProv,
    step1ChildEmail,
    step1ChildPhone,
    step1ChildCellPhone,
    step1ChildDocType,
    step1ChildDocNumber,
    step1ChildDocEmission,
    step1ChildDocExpiration,
    // bonus
    step2Participationlabel,
    step2InpsContributeQuantity,
    step2Grade,
    step2BonusRequested,
    step2BonusType,
    step2BonusSurname,
    step2BonusName,
    step2Portal,
    step2WelfareCode,
    // other
    activeStep,
    step4Marketing,
  } = appState;

  const classes = useStyles();

  return (
    <>
      {hasPaymentError && (
        <div>
          <Alert severity="error">
            <AlertTitle>Attenzione, si è verificato un problema.</AlertTitle>
            Contatta il nostro staff per ricevere assistenza, dal Lun al Ven:
            8:30 - 17:30, ai numeri di telefono 0736 343440 - 0736 336339 Oppure
            riprova più tardi.
          </Alert>

          {/*<Typography variant="body1" gutterBottom>
      Attenzione, si è verificato un problema. Contatta il nostro staff
      per ricevere assistenza, dal Lun al Ven: 8:30 - 19:30 e Sab: 9:00 - 17:00
      ai numeri di telefono 0736 343440 - 0736 336339 Oppure riprova più
      tardi.
  </Typography>
  */}
        </div>
      )}

      <ul
        className={`${
          resumeVariant || isMobile ? classes.noPadding : classes.card
        }`}
      >
        <SectionTitle icon={<Package />} label="La tua prenotazione" />

        <ListItem className={classes.listItem}>
          <ul className={classes.simpleList}>
            {!!step1Catalog && (
              <li className={`${classes.simpleListItem} ${classes.flexColumn}`}>
                <span className={classes.simpleListItemHeader}>
                  <Notebook className={classes.svgBig} />
                  <span>Catalogo</span>
                </span>
                <strong className={classes.strong}>
                  {CATALOGS.find((x) => x.value == step1Catalog).label}
                </strong>
              </li>
            )}
            {!!step1Nation && (
              <li className={`${classes.simpleListItem} ${classes.flexColumn}`}>
                <span className={classes.simpleListItemHeader}>
                  <MapPin className={classes.svgBig} />
                  <span>{nationTitle}</span>
                </span>
                <strong className={classes.strong}>{step1Nation}</strong>
              </li>
            )}
            {!!selectedGroup && (
              <li className={`${classes.simpleListItem} ${classes.flexColumn}`}>
                <span className={classes.simpleListItemHeader}>
                  <Package className={classes.svgBig} />
                  <span> {groupTitle}</span>
                </span>
                <strong className={classes.strong}>
                  {!!selectedTurn && selectedTurn.contractid != null
                    ? `${selectedGroup.label} - ${selectedTurn.contractid}`
                    : selectedGroup.label}
                </strong>
              </li>
            )}
            {!!selectedTurn && (
              <li className={`${classes.simpleListItem} ${classes.flexColumn}`}>
                <span className={classes.simpleListItemHeader}>
                  <Calendar className={classes.svgBig} />
                  <span>{packageTitle || "Turno selezionato"}</span>
                </span>
                <strong className={classes.strong}>{selectedTurn.label}</strong>
              </li>
            )}
            {!!step1DepartureServiceIds && (
              <li className={`${classes.simpleListItem} ${classes.flexColumn}`}>
                <span className={classes.simpleListItemHeader}>
                  <Plane className={classes.svgBig} />
                  <span>{departureTitle}</span>
                </span>

                <strong className={classes.strong}>
                  {(cities.filter((item) => {
                    return item.value === step1DepartureServiceIds;
                  }).length > 0 &&
                    cities.filter((item) => {
                      return item.value === step1DepartureServiceIds;
                    })[0].label) ||
                    "-"}
                </strong>
              </li>
            )}
            {!!step1Structure && (
              <li className={`${classes.simpleListItem} ${classes.flexColumn}`}>
                <span className={classes.simpleListItemHeader}>
                  <Hotel className={classes.svgBig} />
                  <span>{structureTitle}</span>
                </span>
                <strong className={classes.strong}>
                  {structures.filter((item) => item.value === step1Structure)[0]
                    ? structures.filter(
                        (item) => item.value === step1Structure,
                      )[0].label
                    : "-"}
                </strong>
              </li>
            )}
            {!!step1ProgramTypology && (
              <li className={`${classes.simpleListItem} ${classes.flexColumn}`}>
                <span className={classes.simpleListItemHeader}>
                  <NotepadText className={classes.svgBig} />
                  <span>{programTypologyTitle}</span>
                </span>
                <strong className={classes.strong}>
                  {programTypologies.filter(
                    (item) => item.value === step1ProgramTypology,
                  )[0]
                    ? programTypologies.filter(
                        (item) => item.value === step1ProgramTypology,
                      )[0].label
                    : "-"}
                </strong>
              </li>
            )}
          </ul>
        </ListItem>
        <br />
        <SectionTitle icon={<User />} label="Dati anagrafici" />

        <ListItem
          className={clsx(
            classes.listItem,
            resumeVariant && classes.anagraficaColumns,
          )}
        >
          <div className={classes.personBlock}>
            <p className={`${classes.label} ${classes.listItemTitle}`}>
              Cliente
            </p>
            <ul className={classes.simpleList}>
            <li className={classes.simpleListItem}>
              <User className={classes.svg} />
              {step1ParentSurname && step1ParentName && (
                <strong className={classes.strong}>
                  {step1ParentName + " " + step1ParentSurname}
                </strong>
              )}
            </li>
            <li className={classes.simpleListItem}>
              <CreditCard className={classes.svg} />{" "}
              <span>CF: {step1ParentFiscalCode || ""}</span>
            </li>
            <li className={classes.simpleListItem}>
              <MapPin className={classes.svg} />
              <span>
                Indirizzo:
                {step1ParentStreetAddress &&
                  step1ParentResidenceCity &&
                  step1ParentCAP &&
                  step1ParentProv && (
                    <>
                      {step1ParentStreetAddress} - {step1ParentCAP}{" "}
                      {step1ParentResidenceCity} ({step1ParentProv})
                    </>
                  )}
              </span>
            </li>
            <li className={classes.simpleListItem}>
              <Mail className={classes.svg} />{" "}
              <span>Email: {step1ParentEmail || ""}</span>
            </li>
            <li className={classes.simpleListItem}>
              <Phone className={classes.svg} />{" "}
              <span>Telefono fisso: {step1ParentPhoneAlt || ""}</span>
            </li>
            <li className={classes.simpleListItem}>
              <Smartphone className={classes.svg} />
              <span>Telefono cellulare: {step1ParentPhone || ""}</span>
            </li>
          </ul>
          </div>

          <div className={classes.personBlock}>
            <p className={`${classes.label} ${classes.listItemTitle}`}>
              Partecipante
            </p>
            <ul className={classes.simpleList}>
            <li className={classes.simpleListItem}>
              <User className={classes.svg} />
              {step1ChildSurname && step1ChildName && (
                <strong className={classes.strong}>
                  {step1ChildName + " " + step1ChildSurname}
                </strong>
              )}
            </li>
            <li className={classes.simpleListItem}>
              <CreditCard className={classes.svg} />
              <span>CF: {step1ChildFiscalCode || ""}</span>
            </li>
            <li className={classes.simpleListItem}>
              <MapPin className={classes.svg} />
              <span>
                Indirizzo:
                {step1ChildStreetAddress &&
                  step1ChildResidenceCity &&
                  step1ChildCAP &&
                  step1ChildProv && (
                    <>
                      {step1ChildStreetAddress} - {step1ChildCAP}{" "}
                      {step1ChildResidenceCity} ({step1ChildProv})
                    </>
                  )}
              </span>
            </li>
            <li className={classes.simpleListItem}>
              <Mail className={classes.svg} />{" "}
              <span>Email: {step1ChildEmail || ""}</span>
            </li>
            <li className={classes.simpleListItem}>
              <Phone className={classes.svg} />
              <span>Telefono fisso: {step1ChildPhone || ""}</span>
            </li>
            <li className={classes.simpleListItem}>
              <Smartphone className={classes.svg} />
              <span>Telefono cellulare: {step1ChildCellPhone || ""}</span>
            </li>
            {!!step1ChildDocType && !!step1ChildDocNumber && (
              <React.Fragment>
                <li className={classes.simpleListItem}>
                  {step1ChildDocType === "passport"
                    ? "Passaporto"
                    : step1ChildDocType === "idCard"
                    ? "Carta d'identità"
                    : "Documento"}
                  {": "}
                  {step1ChildDocNumber}
                </li>
                {!!step1ChildDocEmission && (
                  <li className={classes.simpleListItem}>
                    Data emissione documento:{" "}
                    {moment(step1ChildDocEmission).format("DD/MM/YYYY")}
                  </li>
                )}
                {!!step1ChildDocExpiration && (
                  <li className={classes.simpleListItem}>
                    Data scadenza documento:{" "}
                    {moment(step1ChildDocExpiration).format("DD/MM/YYYY")}
                  </li>
                )}
              </React.Fragment>
            )}
          </ul>
          </div>

          <ul className="info">
            {!!step2Participationlabel && <li>{step2Participationlabel}</li>}
            {!!step2InpsContributeQuantity && (
              <li className={classes.simpleListItem}>
                Contributo INPS : {step2InpsContributeQuantity}
              </li>
            )}
            {!!step2Grade && <li>Media : {step2Grade}</li>}
            {!!step2BonusRequested && (
              <li className={classes.simpleListItem}>
                {step2BonusType} : {step2BonusSurname + " " + step2BonusName}
              </li>
            )}

            {!!step2Portal && (
              <li className={classes.simpleListItem}>
                Portale : {step2Portal} {step2WelfareCode}
              </li>
            )}
          </ul>
        </ListItem>

        {enableTagManager && (
          <div className="tag_mng">
            <ul>
              {step4Marketing === "si" && (
                <li>
                  <span id="acconsento-mkt">sì</span>
                </li>
              )}
            </ul>
          </div>
        )}
      </ul>
    </>
  );
};

export default Resume;
